import React, { useEffect, useState } from "react";
import styles from "../../pages/OnBoarding/UserOnboarding.module.css";
import pass from "./LoginForm.module.css"   
import cogoToast from "cogo-toast-react-17-fix";
import API from "../../ApiConfig"
import { BASE_URL, SET_PASSWORD, USER_TOKEN, VERIFY_TOKEN } from "../../Utils/constant";
import { Delay } from "../../Utils/helper";
import BtnLoader from "../BtnLoader";
import SlideUpWrapper from "../Transitions/SlideUpWrapper";
import RightContent1 from "./login_right";
import Loader from "../Loader";
import useRefreshToken from "../../Hooks/usegenerateToken";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { BUTTONS } from "../../Utils/Strings";
import { Icon } from 'react-icons-kit'
import {basic_eye} from 'react-icons-kit/linea/basic_eye';
import {basic_eye_closed} from 'react-icons-kit/linea/basic_eye_closed';
const ResetPassword=()=>{
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email')
    const [password,setPassword]=useState('');
    const [confirmPassword,setConfirmPassword]=useState('');
    const [loading,setLoading]=useState(false);
    const [passVisible,setPassVisible]=useState({
        setPass:false,
        confirmPass:false
    })

    const [verifyTokenLoading, setVerifyTokenLoading]=useState(false)
    const location=useLocation()
    
    const navigate=useNavigate();
    const handleResetPassword=async (e)=>{
        e.preventDefault()
        if(ValidatePass()){
            let PassData={
                email:email,
                token:token,
                new_password:password,
                confirm_password:confirmPassword
            }
            setLoading(true)
            await Delay()
            API.put(SET_PASSWORD,{...PassData})
            .then(res=>{
                setLoading(false)
                if(res.status==200){
                    cogoToast.success(res.data.message)  
                    navigate('/app/verify')              
                }
            })
            .catch(err=>{
                setLoading(false)
                cogoToast.error(err.response.data.detail)
            })
        }
        }
        const verifyToken = () => {
            setVerifyTokenLoading(true);
            API.post(VERIFY_TOKEN, { email, token })
              .then(res => {
                const data = res.data.data;
          
                if (data.has_accepted_terms === false) {
                  navigate("/Term-and-Policy", {
                    state: {
                      user_id: data.issuer_id || data.verifier_id,
                      user_type: data.user_type,
                    },
                  });
                  localStorage.setItem("Url", location.pathname + location.search);
                } 
                else if (data.has_accepted_terms === true) {
                  if (data.is_wa_migrated) {
                    const verifyData = {
                      forgot_password_url: location.pathname + location.search,
                      email,
                      user_id: data.user_id,
                    };
                    localStorage.setItem("VerifyData", JSON.stringify(verifyData));
                    navigate("/app/verifyPhone");
                  } else {
                    localStorage.removeItem("VerifyData");
                    localStorage.removeItem("Url");
                  }
                }
              })
              .catch(err => {
                setVerifyTokenLoading(false);
                cogoToast.error(err.message);
              });
          
        }
        useEffect(()=>{
            verifyToken()

        },[])
        const ValidatePass=()=>{
            if(password===""){
                cogoToast.error("Please enter Password")
                return false;
              }
              if(confirmPassword===""){
                cogoToast.error("Please confirm your Password")
                return false;
              }
          
              if(confirmPassword!=password){
                cogoToast.error("Confirm password and password did not match")
                return false;
              }
              return true;
        }
        const handleVisibility=(field)=>{
            
            setPassVisible((prevState) => ({
                ...prevState,
                [field]: !prevState[field]
              }))
        }
    return(
        <SlideUpWrapper direction="slide-left">
        <div className={styles.userOnboarding}>
            <Loader isOpen={loading}/>
            <form className={pass.leftContent} onSubmit={handleResetPassword}>
                <div className={styles.progressForm}>
                    <div className={styles.progressForm1}>
                        <div className={pass.form}>                            
                            <div className={styles.form1}>
                                <img src="/passwordLogo.svg" alt="passwordLogo.svg" className={pass.passwordLogo}/>
                                <div className={styles.headingHelperText}>
                                    <h3 className={pass.Resetheading}>Create a new password</h3>
                                    <div className={pass.supportingText}>
                                        <p className={styles.weMessagedASixDigitCodeT}>
                                        <span className={pass.weMessagedA}>Please choose a password that hasn't been used before.</span>
                                        <span className={pass.weMessagedA}>  Must be at least 8 characters.</span>                              
                                        </p>
                                        <div className={pass.inputdiv}>
                                            <div className={pass.Password}>
                                                <input type={passVisible.setPass?"text":"password"} className={pass.passInput}  id="name" name="name" value={password} placeholder="Set new password" onChange={e=>setPassword(e.target.value)}/>
                                                <span onClick={()=>handleVisibility('setPass')}><Icon icon={passVisible.setPass? basic_eye:basic_eye_closed} size={20}/></span>
                                            </div>
                                            <div className={pass.Password}>
                                               <input type={passVisible.confirmPass?"text":"password"} className={pass.passInput} id="name" name="name" value={confirmPassword} placeholder="Confirm new Password" onChange={e=>setConfirmPassword(e.target.value)}/>
                                               <span onClick={()=>handleVisibility('confirmPass')}><Icon icon={passVisible.confirmPass? basic_eye:basic_eye_closed} size={20}/></span>
                                            </div>
                                        </div>
                                        {password.length>0 && confirmPassword.length>0}
                                        <button type="submit" className={pass.forgotBtn} style={{width:"85%"}}>{loading?<BtnLoader label={BUTTONS.RESET}/>:"Reset password"}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={pass.copyright}>
                Copyright 2026 AuthBridge, All Rights Reserved.
            </div>
            </form>
      <RightContent1 />
        </div>
        </SlideUpWrapper>
    )

}
export default ResetPassword;